import gql from 'graphql-tag';

const query = gql`
  query getThematicSelectionList($projectId: Int!) {
    getThematicSelectionList(projectId: $projectId) {
      id
      name
      createdBy {
        email
        firstName
        lastName
      }
      projectId
      thematics {
        thematic
        subThematic
        subSubThematic
      }
    }
  }
`;

export default query;
